import $ from 'jquery';

import featherlight from 'featherlight';
import featherlightGallery from 'featherlight/release/featherlight.gallery.min';

// import cookieConsent from 'cookieconsent';
// import cookieConsentCss from 'cookieconsent/build/cookieconsent.min.css';

//import aos from 'aos';
//import aosCss from 'aos/dist/aos.css';

import navigationToggle from './navigationToggle';
import mainNavigation from './mainNavigation';
import shopNavigation from './shopNavigation';

import serviceNav from './serviceNav';
import PageChatToggle from './pageChatToggle';

import bodyScrollClass from './bodyScrollClass';
import productTeaserList from './productTeaserList';
import table from './table';
import productImagesPreviews from './productImagesPreviews';

import IntroCarousel from './introCarousel';
import NewsCarousel from './newsCarousel';
import LogoCarousel from './logoCarousel';
import PageDisruptor from './PageDisruptor';

window.$ = $;
window.jQuery = $;

document.addEventListener('DOMContentLoaded', event => {
  navigationToggle();
  mainNavigation();
  shopNavigation();

  serviceNav();

  bodyScrollClass();
  table();
  productTeaserList();
  productImagesPreviews();

  $('.intro-carousel').each((index, element) => {
    new IntroCarousel($(element));
  });

  $('.news-carousel').each((index, element) => {
    new NewsCarousel($(element));
  });

  $('.logo-carousel').each((index, element) => {
    new LogoCarousel($(element));
  });

  $('.page-chat-toggle').each((index, element) => {
    new PageChatToggle($(element));
  });

  new PageDisruptor();

//  aos.init();
});
